export default __webpack_public_path__ + "static/media/testamonialAvatar4.13f13464.png";